export function truncateFields<T>(data: T, maxInputLength: Record<keyof T, number>): T {
    for (const key in data) {
        if (key in maxInputLength) {
            const dataKey = key as keyof T
            const maxLength = maxInputLength[dataKey] ?? 0
            const value = data[dataKey]

            if (typeof value === "string" && value.length > maxLength)
                data[dataKey] = value.substring(0, maxLength) as T[keyof T]
        }
    }
    return data
}
